import assets from "./assets";
import auth from "./auth";
import documents from "./documents";
import notifications from "./notifications";
import organizations from "./organizations";
import projectMembers from "./projectMembers";
import projects from "./projects";
import tasks from "./tasks";
import tracking from "./tracking";
import user from "./user";
import workflows from "./workflows";

export const routes = {
  asset: {
    documents,
    assets,
    projects,
  },
  identity: {
    user,
    organizations,
    projectMembers,
    auth,
  },
  workflows: {
    tasks,
    workflows,
  },
  notifications,
  tracking,
};
